const FlechaOption = ({className}) => {
  return (
    <svg
    className={className}
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3376 0L1.08062 0C0.242118 0 -0.224054 0.969932 0.299757 1.6247L6.24251 9.05314C6.63524 9.54405 7.37817 9.5551 7.78532 9.07609L14.0995 1.64765C14.6516 0.998163 14.19 0 13.3376 0Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default FlechaOption;
